// extracted by mini-css-extract-plugin
export default {"toolbar":"Stats_toolbar__FJp-H","item":"Stats_item__KNNW2","grid":"Stats_grid__XdsUA","detailedMetricsArea":"Stats_detailedMetricsArea__CcT56"};